import { render, staticRenderFns } from "./HouseItem.vue?vue&type=template&id=196f6655&scoped=true"
import script from "./HouseItem.vue?vue&type=script&lang=js"
export * from "./HouseItem.vue?vue&type=script&lang=js"
import style0 from "./HouseItem.vue?vue&type=style&index=0&id=196f6655&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196f6655",
  null
  
)

export default component.exports